import * as React from 'react';
import { Provider } from 'react-redux';
import { browserHistory, IndexRoute, Route, Router } from 'react-router';

import {App} from './App';
import { ArchiveNewsPageContainer } from './components/archiveNewsPage/archiveNewsPageContainer';
import { CertificatesPageContainer } from './components/certificatesPage/certificatesPageContainer';
import { CompetencesPageContainer } from './components/competencesPage/competencesPageContainer';
import { CommonContentPageContainer } from './components/contentPage/contentPageContainer';
import { EventPageContainer } from './components/eventPage/eventPageContainer';
import { EventsArchivePageContainer } from './components/eventsArchivePage/eventsArchivePageContainer';
import { Frontpage } from './components/frontpage';
import { NewsListPageContainer } from './components/newsListPage/newsListPageContainer';
import { NewsPageContainer } from './components/newsPage/newsPageContainer';
import { NotFoundPage } from './components/notFound';
import { store } from './store';

import { setTopNavigationActiveStateAction } from './common/components/topNavigation/actions/fetchTopNavigationMenuItems';

export const AppRouter: React.StatelessComponent<{}> = () => {
  const onRouteChnageHandler = (previousRoute: any, nextRoute: any) => {
    store.dispatch(setTopNavigationActiveStateAction(nextRoute.location.pathname));
    
    (window as any).snoobi.trackPageView(window.location.href);
    (window as any)._elq.trackEvent(window.location.href);
 }
  
  return (
    <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" onChange={onRouteChnageHandler} component={App} >
        <IndexRoute component={Frontpage} />
        <Route path="/ajankohtaista" component={NewsListPageContainer} />
        <Route path="/ajankohtaista(/:categories)" component={NewsListPageContainer} />
        <Route path="/uutiset/ajankohtaista(/:categories)" component={ArchiveNewsPageContainer} />
        <Route path="/uutiset/:id" component={NewsPageContainer} />
        <Route path="/tapahtumat/ajankohtaista(/:categories)" component={EventsArchivePageContainer} />
        <Route path="/tapahtumat/:id" component={EventPageContainer} />
        <Route path= "/loyda_ammattilainen" component={CommonContentPageContainer} />
        <Route path= "/loyda_ammattilainen/:id" component={CommonContentPageContainer} />
        <Route path= "/loyda_ammattilainen/**/:id" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin/:id" component={CommonContentPageContainer} />
        <Route path="/haluan_sertifikaatin/**/:id" component={CommonContentPageContainer} />
        <Route path="/sertifikaatit" component={CertificatesPageContainer} />
        <Route path="/sertifikaatit/:id" component={CommonContentPageContainer} />
        <Route path="/sertifikaatit/**/:id" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta/:id" component={CommonContentPageContainer} />
        <Route path="/ota_yhteytta/**/:id" component={CommonContentPageContainer} />
        <Route path="/patevyydet" component={CompetencesPageContainer} />
        <Route path="/patevyydet/:id" component={CommonContentPageContainer} />
        <Route path="/patevyydet/**/:id" component={CommonContentPageContainer} />
        <Route path="*" component={NotFoundPage} />
      </Route>
    </Router>
    </Provider>
  );
}


// WEBPACK FOOTER //
// ./src/router.tsx